// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"b0651c1f92bbcbd0576c","655":"22e1d89d1728d42c7c31"}[chunkId] + ".js";
};